module.exports = __webpack_public_path__ + "static/media/departamento_paso1.9e4a89f5.png";